import SaveChatFilesToDataRoomToast from './SaveChatFilesToDataRoomToast.component';

export default SaveChatFilesToDataRoomToast;
